var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('Header'),(_vm.show_animation)?_c('SuccessAnimation',{on:{"completed":function($event){_vm.show_animation = false}}}):_vm._e(),_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_c('Snackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }